import type { RGProduct } from "@raumagarn/formatters";
import type { BaseSelectionItem } from "@trydig/centra-types/selection";

export const selectionItemsByGroup = (items?: BaseSelectionItem[]) => {
	const sortWeights: { [key: string]: number } = {
		recipe: 0,
		booklet: 0,
		yarn: 1,
		accessory: 2,
		default: 3,
	};

	const getSortWeight = (item: BaseSelectionItem) => {
		const type = (item?.product as RGProduct | undefined)?.pr_product_type_type;
		return sortWeights[type || ""] ?? sortWeights.default;
	};

	const groups = items?.reduce(
		(
			groups: {
				[key: string]: BaseSelectionItem[];
			},
			item: BaseSelectionItem,
		) => {
			const key = item?.comment ? (JSON.parse(item?.comment ?? "")?.id ?? "default") : "default";

			if (!groups[key]) {
				groups[key] = [];
			}
			groups[key].push(item);

			groups[key].sort((a, b) => {
				const aWeight = getSortWeight(a);
				const bWeight = getSortWeight(b);
				return aWeight - bWeight;
			});

			return groups;
		},
		{},
	);

	if (!groups) {
		return [];
	}

	// TODO: Consider using object indexed by id instead of array to improve performance
	const groupedItems = Object?.keys(groups).map((key) => {
		return {
			id: key,
			itemsIds: groups[key].map((item) => item.line),
			items: groups[key],
		};
	});

	return groupedItems;
};
